export const USER_LOGIN_START = "userLogin/START"
export const USER_LOGIN_SUCCESSFUL = "userLogin/SUCCESSFUL"
export const USER_LOGIN_ERROR = "userLogin/ERROR"
export const USER_SESSION_EXPIRED = "userSession/SESSION_EXPIRED"
export const USER_LOGOUT_USER = 'userSession/LOGOUT_USER';

export const USER_SET_TOKEN = 'userLogin/SET_TOKEN'